import { render, staticRenderFns } from "./TextToSpeech.vue?vue&type=template&id=73f034d8&scoped=true"
import script from "./TextToSpeech.vue?vue&type=script&lang=js"
export * from "./TextToSpeech.vue?vue&type=script&lang=js"
import style0 from "./TextToSpeech.vue?vue&type=style&index=0&id=73f034d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f034d8",
  null
  
)

export default component.exports